/**
 * Indian financial year (April–March) helpers for Create PO.
 * Kept in sync with api/src/utils/fiscalYear.ts (CRA cannot import outside src/).
 */

/**
 * Returns the fiscal year string for a given date using Indian FY (April–March).
 */
export function getFiscalYearString(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  if (month >= 4) {
    const nextYearShort = (year + 1) % 100;
    return `${year}-${nextYearShort.toString().padStart(2, "0")}`;
  }
  const prevYear = year - 1;
  const currentYearShort = year % 100;
  return `${prevYear}-${currentYearShort.toString().padStart(2, "0")}`;
}

const FISCAL_YEAR_PATTERN = /^\d{4}-\d{2}$/;

function previousFiscalYear(fy: string): string {
  const trimmed = fy.trim();
  if (!FISCAL_YEAR_PATTERN.test(trimmed)) {
    throw new Error(`Invalid fiscal year format: ${fy}`);
  }
  const startYear = parseInt(trimmed.slice(0, 4), 10);
  const newStart = startYear - 1;
  const secondPart = (newStart + 1) % 100;
  return `${newStart}-${secondPart.toString().padStart(2, "0")}`;
}

/**
 * Current FY plus the four fiscal years immediately before it (Create PO dropdown).
 */
export function getFiscalYearOptionsForCreatePo(
  referenceDate: Date = new Date()
): string[] {
  const current = getFiscalYearString(referenceDate);
  const out: string[] = [current];
  let fy = current;
  for (let i = 0; i < 4; i++) {
    fy = previousFiscalYear(fy);
    out.push(fy);
  }
  return out;
}
